module.exports = __webpack_public_path__ + "static/media/farmers.633d2f38.svg";